import { AppTheme, LEGALS } from "../../modules/enums";
import Policy from "../../components/fragment/Policy";
import { useTheme } from "../../components/hooks/useTheme";
import { RefundPolicies } from "../../utils/mapper/refundPolicy";

const RefundPolicy = () => {
    const appTheme = useTheme();
    if (appTheme.theme === AppTheme.DARK) appTheme.toggleTheme(AppTheme.LIGHT);

    return (
        <Policy policies={RefundPolicies} type={LEGALS.REFUND_POLICY}
            description={`At truQ, we are committed to providing reliable, transparent, and efficient logistics and financial services. We value the trust our customers place in us, and we strive to ensure that every trip, payment, or transaction on our platform meets the highest standards.
This Refund Policy explains when and how refunds are issued for services booked and paid for through truQ.
`} />
    );
}

export default RefundPolicy;